import api from "api";

const events = {
    get: (grouped, city) => {
        return api().get('/events', {
            params: {
                city: city,
                grouped,
                limit: 500
            }
        })
    },

    filter: (payload) => {
        return api().get('/events', {
            params: { ...payload }
        })
    },

    // Destaques da plataforma para uma cidade. Só devolve eventos que têm lote
    // criado, com os que ainda dá para comprar na frente. Quando a cidade tem
    // menos de 4 resultados o backend amplia sozinho para o estado e depois para
    // o Brasil, e informa até onde foi em `meta.scope` — o título da seção sai daí.
    featured: (params = {}) => {
        return api().get('/events/featured', { params })
    },

    near: ({ lat, long, page = 1, perPage = 9 }) => {
        return api().get(`/events/near/${Number(lat)}/${Number(long)}/${perPage}?page=${page}`)
    },
    allNears: ({ lat, long }) => {
        return api().get(`/events/near/${Number(lat)}/${Number(long)}`)
    },

    findMultiples: ({ lat, long }) => {
        return api().get(`/events`, {
            params: { lat, long }
        })
    },

    getBySlug: (slug, params = {}) => {
        return api().get(`/events/detail/${slug}`, { params })
    },

    autocomplete: (payload) => {
        return api(false, true).get(`/search/${payload}`);
    },

    create: (payload) => {
        return api().post('/events', payload);
    },
    
    update: (slug, payload) => {
        return api().put(`/events/${slug}`, payload);
    },

    delete: (payload) => {
        return api().delete(`/events/${payload}`);
    },

    myEvents: (params) => {
        return api().get('/events/my-events', {
            params: {...params}
        });
    },

    searchEvents: (payload) => {
        return api().get(`/events/my-events?name=${payload}`);
    },

    deleteMyEvents: (payload) => {
        return api().delete(`/events/${payload}`);
    },

    getByEstablishmentId: (establishmentId) => {
        return api().get(`/establishments/${establishmentId}/events`);
    },

    getActiveLocations: () => {
        return api().get('/events/locations/active');
    },

    interest: (eventSlug, status) => {
        return api().post(`/events/${eventSlug}/interest`, { status });
    },

    getParticipantsPreview: (slug) => {
        return api().get(`/events/detail/${slug}/participants/preview`);
    },

    getParticipantsPublic: (slug) => {
        return api().get(`/events/detail/${slug}/participants/public`);
    },

    getTickets: (slug) => api().get(`/events/detail/${slug}/tickets`),

    // Sugestões de produtos geradas por IA a partir do contexto do evento.
    // Sempre devolve 3 itens; `refresh` ignora o cache de 6h do backend.
    getProductSuggestions: (slug, { refresh = false } = {}) => {
        return api().get(`/events/${slug}/products/suggestions`, {
            params: refresh ? { refresh: true } : {}
        });
    },

    getActive: (slug) =>
        api().get(`/establishments/${slug}/pos-events/active`),
};

export default events;  